import React, { useEffect, useState, useMemo } from 'react';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { SET_DROPDOWN_MENU_ITEMS_LIST, IS_EDITING, SHOW_DO_LIST } from "../../actions/types";
import { TransactionsService, CoreService } from "../../services";
import { SaleAtExternalEdit } from './components';
import { ConfirmDialog, WarnDialog } from "../../components/shared";
import SuccessDialog from '../../components/shared/SuccessDialog';
import clsx from 'clsx';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import startOfToday from 'date-fns/startOfToday';
import format from 'date-fns/format';
import {
    Backdrop, Box, Button, Card, CardContent, CircularProgress, Container,
    Grid, IconButton, InputLabel, Paper, TextField, Tooltip, useMediaQuery
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { DataGrid } from '@material-ui/data-grid';
import { makeStyles } from '@material-ui/core/styles';
import { CogOutline, TrashCan, ArrowExpandHorizontal, ArrowCollapseHorizontal } from "mdi-material-ui";
import { red, green } from '@material-ui/core/colors';
import allowAction from '../../helpers/allowAction';
import _ from 'lodash'

const useStyles = makeStyles((theme) => ({
    pageTitleDiv: {
        marginTop: 20,
    },
    pageTitle: {
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 0,
        fontSize: 18,
        color: theme.palette.text.secondary,
        textTransform: 'uppercase'
    },
    cardFiltersContainer: {
        backgroundColor: theme.palette.background.paper
    },
    //cardContentForFiltersContainer: {
    //    display: 'flex',
    //    flexDirection: 'row',
    //    flexWrap: 'nowrap',
    //    backgroundColor: theme.palette.background.paper
    //},
    gridItem: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
    },
    inputLabel: {
        marginTop: 'auto',
        marginBottom: 'auto',
        marginLeft: '1rem',
        marginRight: '1rem',
        color: theme.palette.text.secondary,
        width: '8rem',
        fontSize: 14,
        zIndex: 1000,
        lineHeight: 1.75,
        fontWeight: 'bold',
    },
    searchAndCreateNewButtonsContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    searchButton: {
        //width: 'auto',
        height: 36,
        marginBottom: 5
    },
    createNewButton: {
        //width: 'auto',
        height: 36,
        marginTop: 5
    },
    textField: {
        width: '90%',
        marginTop: 'auto',
        marginBottom: 'auto',
    },
    gridActionsContainer: {
        display: 'flex',
        width: '100%',
        height: 32,
        alignItems: 'center',
        justifyContent: 'flex-end',
        backgroundColor: theme.palette.background.paper,
        borderTopRightRadius: 4,
        borderTopLeftRadius: 4
    },
    saleAtExternalTable: {
        minWidth: 650,
        paddingLeft: 0,
        paddingRight: 0,
        '& .MuiDataGrid-colCellWrapper': {
            backgroundColor: '#86C1D4'
        },
        '& .sale-at-external-table.error': {
            backgroundColor: red[100],
            color: red[600],
        },
        '& .sale-at-external-table.success': {
            backgroundColor: green[100],
            color: green[600],
        },
        '& .sale-at-external-table--header': {
            backgroundColor: '#86C1D4',
            color: 'white',
            fontWeight: 'bold',
        },
        '& svg.MuiSvgIcon-root.MuiDataGrid-iconSeparator': {
            display: 'none'
        }

    },
    table: {
        backgroundColor: theme.palette.background.paper,
    },
    addMaterialReceiving: {
        textAlign: 'center',
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 5000,
    },
}));

export default function SaleAtExternalHome() {
    const history = useHistory();
    const classes = useStyles();
    const dispatch = useDispatch();
    const dropdownItemsStore = useSelector((state) => state.dropdownMenuItems);
    const isEditing = useSelector((state) => state.saleAtExternal.isEditing);

    // Loading
    const [isLoading, setIsLoading] = useState(false);
    const [isTableLoading, setIsTableLoading] = useState(false);
    const [editTicketData, setEditTicketData] = useState('');
    // Dialogs
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' })
    const [openEditDialog, setOpenEditDialog] = useState(false);
    const [openCreateDialog, setOpenCreateDialog] = useState(false)
    const [successDialog, setSuccessDialog] = useState({ isOpen: false, title: '', subTitle: '' });
    const [warnDialog, setWarnDialog] = useState({ isOpen: false, title: '', subTitle: '' });
    //Fix this when backend data mapping finished
    const [searchFormData, setSearchFormData] = useState({
        transactionType: 'Sale',
        loadingDate: startOfToday(),
        bagLq: '',
        materialNo: '',
        doNo: ''
    })
    const [searchAutocompleteData, setSearchAutocompleteData] = useState({})
    // Table
    const [visibilityTable, setVisibilityTable] = useState("hidden")
    const [tableParameters, setTableParameters] = useState({
        dataGridParameters: { "page": 0, "pageSize": 20 }, dataGridSort: {field: '', sort: ''}
    })

    //#region Handle Expand/Collapse Grid
    const isLargeDisplay = useMediaQuery('(min-width: 1500px)');
    //use this to change container props. setting to {maxWidth: false} allows grid to expand full width
    const [containerProps, setContainerProps] = useState('');
    //Grid Actions toolip
    //...need these things to get better control of toolip or else it lingers on expand and collapse
    const [openTooltip, setOpenTooltip] = useState(false)
    const handleShowTooltip = () => {
        setOpenTooltip(true)
    }
    const handleHideTooltip = () => {
        setOpenTooltip(false)
    }
    //#endregion

    const [fetchItem, setfetchItem] = useState({ result: [] });

    useEffect(() => {
        /* Retreive dropdown if they are not already in the Redux store*/
        let dropdownToGet = ['status', 'operationTeam', 'sapStorageLocation', 'sapMaterial', 'bagLq', 'salesOrg', 'shipmentType', 'sapVendorMatser']
        if (dropdownItemsStore) {
            for (var i = 0; i < dropdownToGet.length; i++) {
                if (dropdownItemsStore[dropdownToGet[i]].length !== 0) {
                    dropdownToGet = dropdownToGet.filter(function (item) {
                        return item !== dropdownToGet[i];
                    })
                }
            }
        }
        if (dropdownToGet.length > 0) {
            setIsLoading(true);
            CoreService.dropdownItems(dropdownToGet).then(
                (response) => {
                    if (response && response.data) {
                        const data = response.data;
                        dispatch({
                            type: SET_DROPDOWN_MENU_ITEMS_LIST,
                            payload: data,
                        });
                    }
                    setIsLoading(false);
                });
        }
    }, [dispatch]);

    async function fetchTableDataWithFilter(filters) {
        setfetchItem({ result: [] })
        setIsTableLoading(true);
        TransactionsService.searchTransactionsForExternalSale(filters).then(
            (response) => {
                if (response.data) {
                    setfetchItem(response.data);
                }
                setIsTableLoading(false);

            });
    };

    //#region Handlers
    const handleEditDialogClose = () => {
        setOpenEditDialog(false);
    }
    const handleAddNew = () => {
        dispatch({
            type: SHOW_DO_LIST,
            payload: true,
        });
        //set empty string to init formik validation
        setEditTicketData({
            ticketId: "",
            doNo: "",
            doItem: "",
            salesOrg: "",
            salesCategory: "",
            higherLevelItem: "",
            materialNo: "",
            plantFrom: "",
            slocFrom: "",
            batchNoFrom: "",
            unit: "",
            actQtyDelvSu: "",
            deliveryQty: "",
            pickQtySu: "",
            qtySaleUnit: "",
            netWeight: "",
            grossWeight: "",
            coaNo: "",
            remark: "",
            createBy: "",
            createDate: null,
            modBy: "",
            modDate: null,
            status: "",
            sent: "",
            shipmentType: "",
            containerId: "",
            sealNo: "",
            comments: "",
            transportCom: "",
            truckNo: "",
            driver: "",
            weightIn: "",
            weightOut: "",
            operationTeam: "",
            loadingDate: ""
        })
        dispatch({
            type: IS_EDITING,
            payload: false,
        });
        setOpenEditDialog(true);
    };
    const handleSearchSubmit = () => {
        setVisibilityTable("visible");
        fetchTableDataWithFilter({
            ...searchFormData,
            'dataGridSort': {
                field: '',
                sort: ''
            },
            'dataGridParameters': {}
        });
    };
    const handleSearchAutocompleteChange = (target, fieldName) => {
        var value = target !== null ? target.value : ''
        var text = target !== null ? target.text : ''
        setSearchAutocompleteData({ ...searchAutocompleteData, [fieldName]: { text: text, value: value } })
        setSearchFormData({ ...searchFormData, [fieldName]: value });
    };
    const handleSearchDateChange = (date) => {
        setSearchFormData({ ...searchFormData, loadingDate: date, ...tableParameters });
    };
    const handleSearchDoNoChange = (event) => {
        setSearchFormData({ ...searchFormData, doNo: event.target.value, ...tableParameters });
    };

    const handlePageSizeTransactionsTable = (event) => {
        setTableParameters({ ...tableParameters, 'dataGridParameters': { ...tableParameters.dataGridParameters, pageSize: event } })
        fetchTableDataWithFilter({ ...searchFormData, ...tableParameters, 'dataGridParameters': { ...tableParameters.dataGridParameters, pageSize: event } });
    };
    const handlePageChangeTransactionsTable = (event) => {
        setTableParameters({ ...tableParameters, 'dataGridParameters': { page: event } })
        fetchTableDataWithFilter({ ...searchFormData, ...tableParameters, 'dataGridParameters': { page: event } });
    };
    const handleSortTransactionsTable = (event) => {
        if (!_.isEqual(event[0], tableParameters.dataGridSort)) {
            if (event[0] && event[0].field) {
                setTableParameters({ ...tableParameters, 'dataGridSort': event[0] })
                fetchTableDataWithFilter({ ...searchFormData, ...tableParameters, 'dataGridSort': event[0] });
            } else {
                setTableParameters({ ...tableParameters, 'dataGridSort': { field: '', sort: '' } })
                fetchTableDataWithFilter({ ...searchFormData, ...tableParameters, 'dataGridSort': { field: '', sort: '' } });
            }
        }
    };
    //#endregion

    const rows = useMemo(() => fetchItem.result, [fetchItem]);

    const columns = useMemo(() =>
        [
        {
            field: 'action',
            headerName: 'ACTION',
            width: 90,
            headerClassName: 'sale-at-external-table--header',
            align: 'center',
            sortable: false,
            renderCell: (params) => {
                const onClickEdit = () => {
                    setEditTicketData(params.row);
                    dispatch({
                        type: IS_EDITING,
                        payload: true,
                    });
                    setOpenEditDialog(true);
                };
                const onCancel = () => {
                    let formData = {
                        ticketId: params.row.ticketId,
                        status: "90",
                        slocTo: params.row.slocTo
                    }
                    if (allowAction("301", "cancel")) {
                        TransactionsService.changeStatusByTicketId(formData).then((response) => {
                            setSuccessDialog({
                                isOpen: true,
                                title: 'Ticket Cancelled',
                                subTitle: <><Box component="div">The ticket status has been changed successfully</Box></>,
                            })
                            fetchTableDataWithFilter({ ...searchFormData, ...tableParameters });
                        })
                    } else {
                        setWarnDialog({
                            isOpen: true,
                            title: 'Action Denied',
                            subTitle: <><Box component="div">You don't have permission to cancel a ticket.  If this is a mistake, please contact your administrator.</Box></>,
                        })
                    }
                    
                };
                return (<>
                    <IconButton aria-label="update" className={classes.margin} size="small" onClick={onClickEdit}>
                        <CogOutline />
                    </IconButton>
                    {allowAction('301', 'cancel') ?
                        <IconButton aria-label="delete" className={classes.margin} size="small" onClick={onCancel} disabled={params.row.status === '50'}>
                            <TrashCan />
                        </IconButton>
                        : null}
                </>);
            },
        },
        {
            field: 'bagLq',
            headerName: 'TYPE',
            flex: 1,
            //width: 100,
            headerClassName: 'sale-at-external-table--header',
        },
        {
            field: 'loadingDate',
            headerName: 'LOADING DATE/TIME',
            flex: 2,
            //width: 180,
            valueFormatter: (params) => {
                let date = new Date(params.value);
                return format(date, 'dd-MMM-yyyy HH:mm')
            },
            headerClassName: 'sale-at-external-table--header'
        },
        {
            field: 'doNo',
            headerName: 'DO NO',
            flex: 1,
            //width: 160,
            headerClassName: 'sale-at-external-table--header'
        },
        {
            field: 'ticketId',
            headerName: 'TICKET ID',
            flex: 2,
            //width: 160,
            headerClassName: 'sale-at-external-table--header'
        },
        {
            field: 'truckNo',
            headerName: 'TRUCK NO',
            flex: 2,
            //width: 180,
            headerClassName: 'sale-at-external-table--header'
        },
        {
            field: 'status',
            headerName: 'SUBMIT STATUS',
            flex: 1.5,
            //width: 130,
            align: 'center',
            headerClassName: 'sale-at-external-table--header',
            cellClassName: (params) => clsx('sale-at-external-table', {
                error: params.value === 'Error',
                success: params.value === 'Success',
            }),
            valueFormatter: (params) => dropdownItemsStore["status"].filter(function (status) {
                return status.value === params.value;
            })[0].text,
        },
    ],[fetchItem]);

    return (
        <>
            <Container {...containerProps}>
                <div className={classes.pageTitleDiv}>
                    <h2 className={classes.pageTitle}>
                        Sale At External
                    </h2>
                </div>
                <Grid item xs={12} style={{ marginTop: 10, marginBottom: 10 }}>
                    <Card className={classes.cardFiltersContainer}>
                        <CardContent className={classes.cardContentForFiltersContainer}>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={12} md={10} lg={10}>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} sm={6} md={6} lg={6}>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                {/*<InputLabel className={classes.inputLabel}>*/}
                                                {/*    LOADING DATE:*/}
                                                {/*</InputLabel>*/}
                                                <KeyboardDatePicker
                                                    disableToolbar
                                                    autoOk={true}
                                                    size="small"
                                                    fullWidth
                                                    inputVariant="outlined"
                                                    label={'Loading Date'}
                                                    format="dd-MMM-yyyy"
                                                    id="date"
                                                    value={searchFormData.loadingDate}
                                                    onChange={handleSearchDateChange}
                                                    KeyboardButtonProps={{
                                                        'aria-label': 'change date',
                                                    }}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </Grid>

                                        <Grid item xs={12} sm={4} md={6} lg={6}>
                                            {/*<InputLabel className={classes.inputLabel}>*/}
                                            {/*    TYPE:*/}
                                            {/*    </InputLabel>*/}
                                            <Autocomplete
                                                id="bagLq"
                                                name="bagLq"
                                                blurOnSelect={true}
                                                options={dropdownItemsStore["bagLq"]}
                                                value={searchAutocompleteData.bagLq ? searchAutocompleteData.bagLq : ""}
                                                getOptionLabel={(option) => option.text ? option.text : ""}
                                                getOptionSelected={(option, value) => option.value === value.value}
                                                renderOption={option => <>{option.text}</>}
                                                onChange={(event, newValue) => {
                                                    handleSearchAutocompleteChange(newValue, 'bagLq');
                                                }}
                                                renderInput={(params) => <TextField {...params}
                                                    id="saleType"
                                                    name="saleType"
                                                    size="small"
                                                    label='Type'
                                                    variant="outlined"
                                                />}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={4} md={6} lg={6}>
                                            {/*<InputLabel className={classes.inputLabel}>*/}
                                            {/*    DO NO:*/}
                                            {/*</InputLabel>*/}
                                            <TextField
                                                variant='outlined'
                                                label='Delivery Order Number'
                                                size='small'
                                                fullWidth
                                                //InputProps={{
                                                //   endAdornment:
                                                //       <InputAdornment position="end">
                                                //           <IconButton disabled={true}>
                                                //               <Magnify />
                                                //           </IconButton>
                                                //       </InputAdornment>
                                                //}}
                                                //disabled={dataByDayStore.length === 0}
                                                //value={freeSearchValue}
                                                onChange={(event) => {
                                                    handleSearchDoNoChange(event);
                                                }}
                                            //}}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={4} md={6} lg={6}>
                                            {/*<InputLabel className={classes.inputLabel}>*/}
                                            {/*    MATERIAL:*/}
                                            {/*</InputLabel>*/}
                                            <Autocomplete
                                                //disabled={dataByDayStore.length === 0}
                                                id="materialNo"
                                                name="materialNo"
                                                blurOnSelect={true}
                                                options={dropdownItemsStore["sapMaterial"]}
                                                value={searchAutocompleteData.materialNo ? searchAutocompleteData.materialNo : ""}
                                                getOptionLabel={(option) => option.text ? option.text : ""}
                                                getOptionSelected={(option, value) => option.value === value.value}
                                                renderOption={option => <>{option.text}</>}
                                                onChange={(event, newValue) => {
                                                    handleSearchAutocompleteChange(newValue, 'materialNo');
                                                }}
                                                //options={['1', '2', '3']}
                                                groupBy={(option) => option.firstLetter}
                                                //getOptionLabel={(option) => option.value}
                                                //renderOption={option => <>{option.value}</>}
                                                /*onChange={(event, newValue) => {
                                                    handleSearchMaterialChange(event, newValue);
                                                }}*/
                                                renderInput={(params) => <TextField {...params}
                                                    size="small"
                                                    variant="outlined"
                                                    label='Material'
                                                />}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={12} md={2} lg={2}>
                                    <Grid container spacing={1} style={{ textAlign: "center" }}>
                                        <Grid item xs={12}>
                                            <Button style={{ width: '100%' }} color='default' variant="contained" onClick={handleSearchSubmit}>Search</Button>
                                        </Grid>
                                        <Grid item xs={12}>
                                            {allowAction("301", "create") ?
                                                <Button style={{ width: '100%' }} color="primary" variant="contained" onClick={handleAddNew}>Create New</Button>
                                                : null}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ marginTop: 10, marginBottom: 10 }}>
                    {isLargeDisplay && visibilityTable === 'visible' ?
                        <div className={classes.gridActionsContainer}>
                            <Tooltip
                                title={!containerProps ? 'Expand' : 'Collapse'}
                                open={openTooltip}
                                placement='top'
                            >
                                <IconButton
                                    onMouseEnter={handleShowTooltip}
                                    onMouseLeave={handleHideTooltip}
                                    onClick={() => {
                                        if (!containerProps) {
                                            setContainerProps({ maxWidth: false })
                                        } else {
                                            setContainerProps('')
                                        }
                                        handleHideTooltip()

                                    }
                                    }>
                                    {!containerProps ?
                                        <ArrowExpandHorizontal />
                                        :
                                        <ArrowCollapseHorizontal />
                                    }
                                </IconButton>
                            </Tooltip>
                        </div>
                        :
                        null
                    }

                    <Box px={1.5} visibility={visibilityTable} className={classes.saleAtExternalTable}>
                        <div style={{ height: 600, width: "100%" }}>
                            <DataGrid
                                loading={isTableLoading}
                                className={classes.table}
                                rows={rows}
                                columns={columns}
                                pageSize={tableParameters?.dataGridParameters?.pageSize ?? 20}
                                page={fetchItem.page}
                                rowCount={fetchItem.rowCount}
                                rowsPerPageOptions={[20]}
                                pagination
                                disableColumnMenu={true}
                                disableColumnSelector={true}
                                disableMultipleSelection={true}
                                getRowId={(row) => row.ticketId}
                                paginationMode="server"
                                sortingMode="server"
                                onPageSizeChange={handlePageSizeTransactionsTable}
                                onPageChange={handlePageChangeTransactionsTable}
                                onSortModelChange={handleSortTransactionsTable}
                            />
                        </div>
                    </Box>
                </Grid>
                {openEditDialog ?
                    <SaleAtExternalEdit
                        handleSearchSubmit={handleSearchSubmit}
                        transactionData={editTicketData}
                        setEditTicketData={setEditTicketData}
                        open={openEditDialog}
                        onClose={handleEditDialogClose}
                        setIsLoading={setIsLoading}
                    />
                    : ''
                }
            </Container >
            <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
            />
            <SuccessDialog
                successDialog={successDialog}
                setSuccessDialog={setSuccessDialog}
            />
            <WarnDialog
                warnDialog={warnDialog}
                setWarnDialog={setWarnDialog}
            />
            <Backdrop className={classes.backdrop} open={isLoading} timeout={{ enter: 1100 }}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}
